import BarPercentage from './bar-percentage'

export { BarPercentage }
